import React from 'react';
import dayjs from 'dayjs';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material';
import { COLORS } from '../../../Components/colors';

const FONT = {
  label: '11px',
  value: '11px',
  title: '1.1rem'
};

const ROW_HEIGHT = 32;

const LEFT_COL_WIDTHS = ['50%', '40%'];
const RIGHT_COL_WIDTHS = ['25%', '35%', '10%', '40%'];

const cell = {
  border: `1px solid ${COLORS.borderTable}`,
  padding: '4px 8px',
  whiteSpace: 'nowrap',
  fontSize: FONT.label,
  fontFamily: '"Poppins", sans-serif'
};

const OTBReportHeader = ({ reportData, pickupDaysLabel, displaySettings, selectedRows, data, showLegalName }) => {
  const fromDate = reportData?.ShortFromDate ? dayjs(reportData.ShortFromDate).format('MMMM DD, YYYY') : '';
  const toDate = reportData?.ShortToDate ? dayjs(reportData.ShortToDate).format('MMMM DD, YYYY') : '';
  const pickupDays = pickupDaysLabel || '';

  let corpName = '-';
  let profitCenter = '-';
  let brandName = '-';

  if (selectedRows && selectedRows.length > 1) {
    corpName = 'Multiple';
    profitCenter = 'Multiple';
    brandName = 'Multiple';
  } else if (data && data.length > 0) {
    corpName = (showLegalName ? data[0].CorpLegalName : data[0].Corpname) || data[0].Corpname || '-';
    profitCenter = data[0].PCName || '-';
    brandName = data[0].BrandName || '-';
  } else if (selectedRows && selectedRows.length === 1) {
    corpName = selectedRows[0].corpName || '-';
    profitCenter = selectedRows[0].legalName || '-';
    brandName = selectedRows[0].brand || '-';
  }

  const formatText = (text) => {
    if (!text || typeof text !== 'string') return text;
    if (displaySettings?.textFormat === 'upper') return text.toUpperCase();
    if (displaySettings?.textFormat === 'lower') return text.toLowerCase();
    return text;
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '360px 1fr 360px',

        alignItems: 'stretch',
        width: '100%'
      }}
    >
      {/* LEFT TABLE */}
      <TableContainer>
        <Table size="small" sx={{ tableLayout: 'fixed' }}>
          <TableBody>
            {[
              ['Corporation/Legal Name', corpName],
              ['Profit Center', profitCenter],
              ['Brand Name', brandName]
            ].map((row, i) => (
              <TableRow key={i} sx={{ height: ROW_HEIGHT }}>
                <TableCell sx={{ ...cell, width: LEFT_COL_WIDTHS[0],color: COLORS.textBlack }}>
                  {formatText(row[0])}
                </TableCell>
                <TableCell
                  sx={{
                    ...cell,
                    width: LEFT_COL_WIDTHS[1],
                    fontWeight: 600,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 1 // Required for ellipsis to work in table-cell
                  }}
                  title={formatText(row[1])}
                >
                  {formatText(row[1])}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* CENTER TITLE */}
      <Box
        sx={{
          border: `1px solid ${COLORS.borderTable}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography sx={{ fontSize: FONT.title, fontWeight: 700 }}>
          {formatText('OTB Report')}
        </Typography>
      </Box>

      {/* RIGHT TABLE */}
      <TableContainer>
        <Table size="small" sx={{ tableLayout: 'fixed', maxHeight: "auto" }}>
          <TableBody>
            {[
              ['Date', fromDate, 'To', toDate],
              ['Pickup Days', pickupDays, '', '']
            ].map((row, i) => (
              <TableRow key={i} sx={{ height: (ROW_HEIGHT * 3) / 2 }}>
                {row.map((cellData, idx) => (
                  <TableCell
                    key={idx}
                    sx={{
                      ...cell,
                      width: RIGHT_COL_WIDTHS[idx],
                      color: COLORS.textBlack
                    }}
                  >
                    {formatText(cellData)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default React.memo(OTBReportHeader);
